export default __webpack_public_path__ + "static/media/whiterightMore.d139af36.svg";